import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { getColor, spacingUnits, StyleVars } from 'core/utils';

const MIN_HEIGHT = 600;
const MOBILE_HEIGHT = 450;

const shimmer = keyframes`
	0% { background-position: -468px 0; }
	100% { background-position: 468px 0; }
`;

export const backgroundShimmer = (height) => css`
	animation: ${shimmer} 1s linear infinite forwards;
	background: ${getColor('porcelain')};
	background: linear-gradient(to right, ${getColor('gray1')} 8%, ${getColor('gray2')} 18%, ${getColor('gray1')} 33%);
	background-size: 800px 104px;
	height: ${height || MIN_HEIGHT}px;
	position: relative;
`;

export const backgroundMask = css`
	background: ${getColor('white')};
	position: absolute;
`;

// Outer container with that background shimmer
const Placeholder = styled.div`
	background: ${getColor('white')};
	min-height: ${MIN_HEIGHT}px;
	${backgroundShimmer(MIN_HEIGHT)};

	/* Page-specific */
	max-width: 1280px;
	margin: ${spacingUnits(2.5)} auto;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		min-height: ${MOBILE_HEIGHT}px;
		${backgroundShimmer(MOBILE_HEIGHT)};
	}
`;

const TitleMask = styled.div`
	${backgroundMask}
	top: 44px;
	left: 0;
	right: 0;
	height: 24px;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		height: 16px;
	}
`;

const MidTitleMask = styled.div`
	${backgroundMask}
	top: 0;
	left: 300px;
	right: 160px;
	height: 44px;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		display: none;
	}
`;

const LeftMarginMask = styled.div`
	${backgroundMask}
	top: 0;
	left: 0;
	height: 100%;
	width: 16px;
`;

const RightMarginMask = styled.div`
	${backgroundMask}
	top: 0;
	right: 0;
	height: 100%;
	width: 16px;
`;

const ColumnMask = styled.div`
	${backgroundMask}
	top: 68px;
	left: 66%;
	right: 0;
	height: ${MIN_HEIGHT - 68}px;
	width: 32px;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		display: none;
	}
`;

const SidebarMask = styled.div`
	${backgroundMask}
	top: 420px;
	right: 16px;
	height: 32px;
	width: calc(100% - 66% - 48px);

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		top: ${MOBILE_HEIGHT - 60}px;
		right: 0;
		height: 16px;
		width: 100%;
	}
`;

const CartItemMask = styled.div`
	${backgroundMask}
	top: 340px;
	left: 0;
	height: ${MIN_HEIGHT - 340}px;
	width: 66%;

	@media (max-width: ${StyleVars.desktopScreenSm}) {
		top: 104px;
		height: 16px;
		width: 100%;
	}
`;

const CartPlaceholders = () => (
	<Placeholder>
		<LeftMarginMask />
		<RightMarginMask />
		<MidTitleMask />
		<TitleMask />
		<ColumnMask />
		<CartItemMask />
		<SidebarMask />
	</Placeholder>
);

export default CartPlaceholders;
